export function decodeExport(contents: string): string {
    const trimmed = contents.trim();
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) return trimmed;

    const binary = atob(trimmed);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
}
